// Central site content for Verified Workforce
export const SITE = {
  name: "Verified Workforce",
  tagline: "Reliable People. Verified Results.",
  campaign: "Building Better Supply Chains. Creating Better Opportunities.",
  subline:
    "Verified Workforce connects major construction clients with capable specialist contractors — while helping ambitious SMEs become compliant, commercially ready and equipped to deliver larger contracts.",
  logo:
    "https://customer-assets.emergentagent.com/job_vw-construction/artifacts/y6z8njrl_abff2743c64859fb476af36b9403551685de8c4186b58b318d03e4230c5dd4e9.png",
  contact: {
    email: "Robert@verifiedworkforce.co.uk",
    phone: "07883 517113",
    phoneRaw: "+447883517113",
    addressLine1: "Regus",
    addressLine2: "Bromley, United Kingdom",
    founded: "2025",
    linkedin: "https://www.linkedin.com/",
  },
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/for-clients", label: "For Clients" },
  { to: "/delivery-partners", label: "Delivery Partners" },
  { to: "/compliance", label: "Compliance" },
  { to: "/finance", label: "Finance Support" },
  { to: "/opportunities", label: "Opportunities" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const PILLARS = [
  {
    key: "supply-chain",
    label: "Supply Chain",
    body: "Specialist contractor sourcing, package procurement and supply-chain development.",
  },
  {
    key: "compliance",
    label: "Compliance",
    body: "Help contractors build the Health & Safety, SSIP and documentation systems larger clients expect.",
  },
  {
    key: "finance",
    label: "Finance",
    body: "Introductions to specialist construction finance partners for eligible Delivery Partners.",
  },
  {
    key: "delivery",
    label: "Delivery",
    body: "Mobilisation, oversight and performance monitoring across the Delivery Partner network.",
  },
];

export const JOURNEY = [
  { title: "Identify", body: "We find capable specialist construction businesses." },
  { title: "Develop", body: "We identify compliance and commercial gaps." },
  { title: "Verify", body: "We review relevant documentation, experience and capability." },
  { title: "Connect", body: "Suitable Delivery Partners are matched with relevant opportunities." },
  { title: "Support", body: "Mobilisation support and introductions to specialist compliance and finance partners where required." },
  { title: "Deliver", body: "Performance is monitored to build a stronger long-term supply chain." },
];

export const CLIENT_SERVICES = [
  "Specialist subcontractor sourcing",
  "Supply-chain development",
  "Contractor pre-qualification",
  "Package procurement",
  "Compliance readiness",
  "Mobilisation support",
  "Capacity sourcing",
  "Performance monitoring",
  "Replacement contractor sourcing",
];

export const CLIENT_TYPES = [
  "Principal Contractors",
  "Tier 1 Contractors",
  "Tier 2 Contractors",
  "Developers",
  "Housing Associations",
  "Councils",
  "Facilities Management",
  "Project Management Companies",
];

export const CLIENT_BENEFITS = [
  {
    title: "Capacity",
    body: "Access additional specialist contractors when existing supply chains are stretched.",
  },
  {
    title: "Compliance",
    body: "Develop and identify businesses capable of meeting increasingly demanding supply-chain requirements.",
  },
  {
    title: "Commercial Resilience",
    body: "Where appropriate, contractors can explore finance support that may improve their ability to mobilise and sustain delivery.",
  },
  {
    title: "Specialist Procurement",
    body: "Source businesses around individual trades, work packages and programmes rather than relying only on general contractors.",
  },
];

export const COMPLIANCE_AREAS = [
  { title: "SSIP Pathways", body: "Support contractors in understanding and progressing towards recognised SSIP requirements where required by clients." },
  { title: "Health & Safety", body: "Help businesses identify the Health & Safety policies, procedures and documentation expected within larger construction supply chains." },
  { title: "RAMS", body: "Support with the processes required for suitable Risk Assessments and Method Statements." },
  { title: "Method Statements", body: "Help contractors develop professional processes for documenting how works will be safely delivered." },
  { title: "PQQ Readiness", body: "Help contractors prepare for contractor questionnaires and pre-qualification requirements." },
  { title: "Insurance & Documentation", body: "Help contractors understand and organise the documentation typically requested during supply-chain onboarding." },
  { title: "Training & Competency", body: "Identify gaps between current workforce competency and client requirements." },
  { title: "ISO Pathways", body: "Where appropriate, help contractors understand pathways towards ISO standards and other recognised systems." },
];

export const NETWORK_TIERS = [
  { key: "registered", label: "Registered Contractor", body: "Company has registered interest." },
  { key: "developing", label: "Developing Partner", body: "Company is progressing through compliance and readiness requirements." },
  { key: "verified", label: "Verified Delivery Partner", body: "Verified Workforce has reviewed defined company information and documentation." },
  { key: "preferred", label: "Preferred Delivery Partner", body: "Contractor has demonstrated successful delivery and ongoing performance." },
];

export const TRADES = [
  "General Building", "Kitchens", "Bathrooms", "Voids", "Roofing", "Scaffolding",
  "Groundworks", "Civils", "Brickwork", "Cladding", "Concrete Repairs",
  "Passive Fire Protection", "Fire Stopping", "Electrical", "Mechanical",
  "Carpentry", "Joinery", "Drylining", "Painting & Decorating", "Windows",
  "Curtain Walling", "Steelwork", "Landscaping", "Other",
];

export const REGIONS = [
  "London", "South East", "South West", "East of England", "Midlands",
  "North West", "North East", "Yorkshire & Humber", "Scotland", "Wales", "National",
];

export const TURNOVER_BANDS = [
  "Under £250k", "£250k – £500k", "£500k – £1m", "£1m – £2.5m",
  "£2.5m – £5m", "£5m – £10m", "£10m +",
];

export const PACKAGE_VALUES = [
  "Under £25k", "£25k – £100k", "£100k – £250k",
  "£250k – £500k", "£500k – £1m", "£1m +",
];

export const CLIENT_TYPE_OPTIONS = [
  "Housing Association", "Council / Local Authority", "Principal Contractor",
  "Tier 1 Contractor", "Tier 2 Contractor", "Developer", "FM / Asset Owner", "Private",
];
